import { Col, Collapse, Row, Tooltip } from "antd";
import React from "react";
import TagComponent from "../../../../biblio/TagComponent";
import dayjs from "dayjs";
import { DownloadOutlined } from "@ant-design/icons";

interface EducationalMonitoringProps {
  requests: any;
}
const EducationalMonitoringCollapse = ({
  requests,
}: EducationalMonitoringProps) => {
  const handleDownload = (attachment: any) => {
    if (attachment && attachment.datas && attachment.filename) {
      const link = document.createElement("a");
      link.href = `data:application/octet-stream;base64,${attachment.datas}`;
      link.download = attachment.filename;
      link.click();
    }
  };
  return (
    <div className="takaful--collapse-profile-container">
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          showArrow={false}
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم التسجيل
                  </p>
                </Col>
                <Col
                  xxl={7}
                  xl={7}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ التسجيل
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    المستفيد
                  </p>
                </Col>
                <Col
                  xxl={5}
                  xl={5}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  style={{ paddingRight: "1.5rem" }}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">المرحلة</p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={["0"]}
      >
        {requests?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  justify={"space-between"}
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0" }}
                >
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      رقم التسجيل
                    </p>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.name}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      تاريخ التسجيل
                    </p>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--date-format">
                      {element?.date
                        ? dayjs(element?.date, "YYYY-MM-DD").format(
                            "YYYY/MM/DD"
                          )
                        : ""}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المستفيد
                    </p>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element && element?.partner_id[1]}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                    المرحلة
                    </p>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <TagComponent
                      className="takaful--tag-component"
                      width="70%"
                      state={element?.state}
                      orangeValue="in_progress"
                      greenValue="done"
                      redValue="cancel"
                      text={element && element?.stage_id[1]}
                    />
                  </Col>
                </Row>
              </div>
            }
          >
            <Row
              className={`takaful--content-profile-box1`}
              justify={"space-between"}
              gutter={16}
            >
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  المستوى الدراسي بالمدرسة :
                </p>
              </Col>
              <Col
                xxl={8}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.school_level}
                </span>
              </Col>
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  عدد سنوات إنظمامه بالمنحة التعليمية :
                </p>
              </Col>
              <Col
                xxl={8}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.enrolling_years_number}
                </span>
              </Col>
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  المعدل التراكمي :
                </p>
              </Col>
              <Col
                xxl={8}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.accumulated_rate}
                </span>
              </Col>
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  الجامعة التي تقدم عليها :
                </p>
              </Col>
              <Col
                xxl={8}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element && element?.university_id[1]}
                </span>
              </Col>
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  عدد الإنذارات :
                </p>
              </Col>
              <Col
                xxl={8}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.warning_number}
                </span>
              </Col>
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  الإنجازات و الشهادات :
                </p>
              </Col>
              <Col
                xxl={8}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.certificate_achievement} {"  "}
                  {Array.isArray(element?.certificate_achievement_ids) &&
                    element.certificate_achievement_ids.length > 0 &&
                    element.certificate_achievement_ids.map(
                      (certificate: any, index: any) => (
                        <Tooltip
                          overlayClassName="takaful--share-tooltip"
                          key={index}
                          title={certificate.filename}
                        >
                          <DownloadOutlined
                            className="takaful--download-icon takaful--service-download-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDownload(certificate);
                            }}
                          />
                        </Tooltip>
                      )
                    )}
                </span>
              </Col>
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">التخصص :</p>
              </Col>
              <Col
                xxl={8}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.speciality}
                </span>
              </Col>
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              ></Col>
              <Col
                xxl={8}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              ></Col>
            </Row>
            {element.refuse_reason !== false && (
              <Row gutter={16} className={`takaful--content-profile-box1`}>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={5}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    سبب الرفض :
                  </p>
                </Col>
                <Col
                  xxl={18}
                  xl={18}
                  lg={18}
                  md={18}
                  sm={18}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.refuse_reason}
                  </span>
                </Col>
              </Row>
            )}
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default EducationalMonitoringCollapse;
